import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBusiness } from '../contexts/BusinessContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Building2, Plus } from 'lucide-react';

const BusinessSelector = () => {
  const navigate = useNavigate();
  const { businesses } = useAuth();
  const { switchBusiness } = useBusiness();

  const handleSelectBusiness = async (businessId) => {
    // Find the business data with role information
    const businessData = businesses.find(b => b.id === businessId);
    await switchBusiness(businessId, businessData);
    navigate(`/business/${businessId}/dashboard`);
  };

  const handleCreateNew = () => {
    navigate('/create-business');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Select Business</h1>
          <p className="text-gray-600">Choose a business to manage</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {businesses.map((business) => (
            <Card
              key={business.id}
              data-testid={`business-card-${business.id}`}
              className="cursor-pointer hover:shadow-lg transition-shadow"
              onClick={() => handleSelectBusiness(business.id)}
            >
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gray-100 rounded-lg">
                    <Building2 className="w-6 h-6 text-gray-700" />
                  </div>
                  <div>
                    <CardTitle>{business.name}</CardTitle>
                    {business.phone && (
                      <CardDescription>{business.phone}</CardDescription>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-sm text-gray-600">
                  {business.city && business.state && (
                    <p>
                      {business.city}, {business.state}
                    </p>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}

          {/* Create New Business Card */}
          <Card
            data-testid="create-business-card"
            className="cursor-pointer hover:shadow-lg transition-shadow border-dashed border-2"
            onClick={handleCreateNew}
          >
            <CardContent className="flex flex-col items-center justify-center h-full py-12">
              <Plus className="w-12 h-12 text-gray-400 mb-4" />
              <p className="text-lg font-medium text-gray-700">Create New Business</p>
              <p className="text-sm text-gray-500 mt-1">Start managing a new business</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BusinessSelector;